// extracted by mini-css-extract-plugin
module.exports = {"mop-container":"_1-RqO","mop-details":"_3sdDt","mop-masked-digits":"_2HBWB","mop-name":"__ZY8","mop-img":"_1IvU6"};